import { initEnvironmentReact } from '../../shared/initEnvironmentReact'

export const appVersion = import.meta.env.VITE_SENTRY_RELEASE || initEnvironmentReact.SENTRY_RELEASE || 'dev'
